import i18next from 'i18next';
var validateRequiredI18n = function validateRequiredI18n(value) {
  return !value ? i18next.t('validation:required') : null;
};
export default validateRequiredI18n;